module.exports = __webpack_public_path__ + "3cb49034792021dc5780301c2132362b.png";